export const cut = (text, count = 55) => {
    const sliced = text.slice(0, count);
    return `${sliced}${(sliced.length < text.length) ? '...' : ''}`;
}


